import { Component } from '@angular/core';

@Component({
	selector: 'app-faq-manager-showcase',
	templateUrl: './faq-manager-showcase.component.html',
	styleUrls: ['./faq-manager-showcase.component.scss'],
	standalone: false,
})
export class FAQManagerShowcaseComponent {
	constructor() {}
}
